import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  namespaced: true,
  state() {
    return {
      vat: {
        loading: false,
        value: 0,
      },
    };
  },
  mutations: {
    setVat(state, value) {
      state.vat.value = value;
    },
    setLoading(state, loading) {
      state.vat.loading = loading;
    },
  },
  actions: {
    async fetchVat({ commit, getters }) {
      const vatvalue = getters['getVat'];
      const loading = getters['getVatLoading'];
      if (vatvalue || loading) return;
      commit('setLoading', true);
      try {
        const response = await axios({
          url: `${apiUrl}/vat`,
        });

        const vat = response.data.data;
        commit('setVat', vat);
      } catch (error) {
        console.error(error);
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    getVat(state) {
      return state.vat.value;
    },
    getVatLoading(state) {
      return state.vat.loading;
    },
  },
};
